import CommentsRender from './comments-render'

export default CommentsRender
